export default {
  buttons: {
    send_code: 'Enviar código de acesso',
  },
  placeholders: {
    mobile_number: 'Número de telemóvel',
    email: 'Endereço de Email',
  },
  feedback: {
    phone_number_required: 'Por favor, introduza o seu número de telefone',
    email_required: 'Introduza o seu endereço de email',
  },
};
